var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 12.941C20 15.731 17.76 17.991 14.97 18.001H14.96H5.05C2.27 18.001 0 15.751 0 12.961V12.951C0 12.951 0.006 8.52498 0.014 6.29898C0.015 5.88098 0.495 5.64698 0.822 5.90698C3.198 7.79198 7.447 11.229 7.5 11.274C8.21 11.843 9.11 12.164 10.03 12.164C10.95 12.164 11.85 11.843 12.56 11.263C12.613 11.228 16.767 7.89398 19.179 5.97798C19.507 5.71698 19.989 5.95098 19.99 6.36798C20 8.57698 20 12.941 20 12.941Z",
    fill: "url(#paint0_linear_458_14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4761 2.674C18.6101 1.042 16.9061 0 15.0301 0H5.05013C3.17413 0 1.47013 1.042 0.604128 2.674C0.410128 3.039 0.502128 3.494 0.825128 3.752L8.25013 9.691C8.77013 10.111 9.40013 10.32 10.0301 10.32C10.0341 10.32 10.0371 10.32 10.0401 10.32C10.0431 10.32 10.0471 10.32 10.0501 10.32C10.6801 10.32 11.3101 10.111 11.8301 9.691L19.2551 3.752C19.5781 3.494 19.6701 3.039 19.4761 2.674Z",
    fill: "url(#paint1_linear_458_14)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_14",
    x1: 3.75723,
    y1: 5.79785,
    x2: 17.0753,
    y2: 12.3074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_458_14",
    x1: 4.08642,
    y1: -2.19083e-7,
    x2: 16.1554,
    y2: 6.65245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15C39A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09D7A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.b77d87318c06f693df6d356543ed3349.svg";
export { ForwardRef as ReactComponent };